(function () {
    'use strict';

    function initFooterSocials() {
        var socials = document.querySelector('[data-footer-socials]');

        if (!socials) return;

        var footer = socials.closest('.footer');
        var contacts = footer ? footer.querySelector('.footer__contacts') : null;
        var schedule = footer ? footer.querySelector('.footer__schedule') : null;
        var bottomContent = footer ? footer.querySelector('.footer__bottom-content') : null;
        var mobileMedia = window.matchMedia('(max-width: 768px)');

        if (!footer || !contacts || !bottomContent) return;

        function updateSocialsPosition() {
            if (mobileMedia.matches) {
                if (schedule) {
                    schedule.insertAdjacentElement('afterend', socials);
                } else {
                    contacts.appendChild(socials);
                }

                return;
            }

            bottomContent.parentNode.insertBefore(socials, bottomContent);
        }

        if (typeof mobileMedia.addEventListener === 'function') {
            mobileMedia.addEventListener('change', updateSocialsPosition);
        } else {
            mobileMedia.addListener(updateSocialsPosition);
        }

        updateSocialsPosition();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFooterSocials);
    } else {
        initFooterSocials();
    }
}());
